var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26875 0 0 6.26875 0 14C0 21.7313 6.26875 28 14 28C21.7313 28 28 21.7313 28 14C28 6.26875 21.7313 0 14 0ZM18.5031 14.2156L11.6781 19.1812C11.6407 19.2081 11.5966 19.2242 11.5507 19.2276C11.5047 19.2311 11.4587 19.2218 11.4177 19.2008C11.3767 19.1798 11.3422 19.1479 11.3182 19.1087C11.2941 19.0694 11.2813 19.0242 11.2812 18.9781V9.05313C11.2811 9.00696 11.2937 8.96165 11.3178 8.92222C11.3418 8.8828 11.3762 8.85079 11.4173 8.82976C11.4584 8.80873 11.5046 8.79948 11.5506 8.80305C11.5966 8.80663 11.6408 8.82288 11.6781 8.85L18.5031 13.8125C18.5354 13.8353 18.5617 13.8655 18.5798 13.9006C18.598 13.9357 18.6075 13.9746 18.6075 14.0141C18.6075 14.0536 18.598 14.0925 18.5798 14.1275C18.5617 14.1626 18.5354 14.1928 18.5031 14.2156Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.8728cec50dab2a82d2998dce040a9fcf.svg";
export { ForwardRef as ReactComponent };